import { Icon } from '@/new/components/icon';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/new/components/shadcn/tooltip';

const OCR_REVIEW_THRESHOLD = 30;

export const SourceConfidenceWarning = ({ sourceConfidence }: { sourceConfidence?: number }) => {
  if (sourceConfidence == null || Math.round(sourceConfidence) >= OCR_REVIEW_THRESHOLD) return null;

  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger asChild>
        <span className="flex items-center gap-1 text-gray-500">
          <Icon className="lucide--alert-triangle text-amber-500" />
          Review text extraction
        </span>
      </TooltipTrigger>
      <TooltipContent side="top">
        We detected anomalies when parsing this source. Please verify extracted content.
      </TooltipContent>
    </Tooltip>
  );
};
